import React, { useState, useEffect } from 'react'
import {Form, Button} from "react-bootstrap";
import axios from 'axios';
import {useTranslation} from "react-i18next";
import Switch from "react-switch";


function OGNSettings({drone}){
    const { t } = useTranslation(['modem']);
    const [ognId, setOgnId] = useState(drone.ognId);
    const [ognSaveInfo, setOgnSaveInfo] = useState("");
    const [isFrVis, setIsFrVis] = useState(drone.isFrVis);
    const [enabledSaveButton, setEnabledSaveButton] = useState(false);

    useEffect(() => {
        setOgnId(drone.ognId);
        setOgnSaveInfo("");
        setIsFrVis(drone.isFrVis);
    }, [drone]);

    /*useEffect(() => {
        setOgnSaveInfo("");
        setEnabledSaveButton(true);
    }, [modemSettings, rtspStr, fpvModeSettings, fpvLatencySettings]);
*/
    function saveOgnId(){
        axios.post('api/fr/setOgnId', {ognId: ognId, imei: drone.imei})
            .then(response => {
                setOgnSaveInfo(t('successfully'));
        })
        .catch(exception => {
            setOgnSaveInfo(t('ogn_error'));
        });
    }

    function switchFrVis(){
        axios.post('api/fr/setOgnView', {isFrVis: !isFrVis, imei: drone.imei})
            .then(response => {
                console.log(response);
        });
        setIsFrVis(!isFrVis);
    }

    return(
        <>
            <div className='t-18 ts-16'>OGN id:</div>
            <div className='settings-grid ts-16'>
                <div className='grid-4'>
                    <Form.Control type="text" placeholder={ognId} onChange={(event) => {setOgnId(event.target.value)}} />
                </div>
            </div>
            <div className='settings-grid ts-16'>
                <Button onClick={saveOgnId}>{t('save')}</Button>
                <div className='grid-ogn'>
                    <div className='ogn-switch'>
                        <Switch onChange={() => {switchFrVis()}} checked={isFrVis} uncheckedIcon={false} checkedIcon={false} onColor='#EBFF00' onHandleColor='#000000' offHandleColor='#000000' offColor='#494949'/>
                    </div>
                    <div>
                        {t('send_data_to_ogn')}
                    </div>
                </div>
                
            </div>
            <div className='settings-grid ts-16'>
                <div>{ognSaveInfo}</div>
            </div>
            <div className='grid-max'>
                <hr/>
            </div>
            <div className='settings-grid ts-16'>
                <div className='grid-max ts-16 t-14'>
                    Данные, которые отправляет модем AIR-LINK в сервис OGN, будут транслироваться через интернет на ближайшие наземные станции OGN, информация с которых будет отправлена летальным аппаратам поблизости.
                    Также они будут отправлены в сервисы отслеживания воздушных судов, таких как <a target="_blank" href='https://www.flightradar24.com/'>FlightRadar24</a>,
                    <a target="_blank" href='http://live.glidernet.org/'> OGN</a>, <a target="_blank" href='https://www.radarbox.com/'> RadarBox</a>.
                </div>
                <div className='grid-max ts-16 t-14'>
                    Для отправки данных в OGN необходимо получить регистрационный номер на сайте <a target="_blank" href='https://ddb.glidernet.org/'>glidernet</a>.
                </div>
            </div>
        </>
    )
}

export default OGNSettings;
